import React, { Fragment, useState } from 'react';
import { Link } from 'react-router-dom'
import Header from '../../components/header/Header';
import PageTitle from '../../components/pagetitle/PageTitle'
import Scrollbar from '../../components/scrollbar/scrollbar'
import Footer from '../../components/footer/Footer';
import ModalVideo from 'react-modal-video'
import CtaSection from '../../components/CtaSection/CtaSection';
// import PolicySection from './Policy';
import offerBanner from '../../images/icons/best_offer.svg.svg';
import PartnerSection from '../../components/PartnerSection';


const EnterprisePlans = (props) => {

    const [isOpen, setOpen] = useState(false)

    const [isActive, setIsActive] = useState(false);

    const handleToggle = () => {
        setIsActive(!isActive);
    };


    return (
        <Fragment>
            <Header />
            <main className="page_content plans-page">
                <PageTitle pageTitle={'Enterprise Plans'} pagesub={'Plans 😍'} pageTop={'Our'} />
                {/* <PolicySection /> */}
                <section className="pricing_section section_space pb-0 bg-light">
                    <div className="container">
                        <div className="heading_block text-center">
                            <div className="heading_focus_text mb-2">
                                Our
                                <span className="badge bg-secondary text-white">Plans 😍</span>
                            </div>
                            <h2 className="heading_text mb-0">
                                Best Enterprise Plans
                            </h2>
                        </div>
                        <div className="pricing_toggle_btn text-center">
                            <button type="button" onClick={handleToggle} className={isActive ? 'active' : ''}>
                                <span>Billed Monthly</span>
                                <span>Billed Annual <small>-10%</small></span>
                            </button>
                        </div>
                        <div className="row justify-content-center box_border">
                            <div className="col-lg-6">
                                <div className={`pricing_block ${isActive ? 'active' : ''}`}>
                                    <div className="table_head">
                                        <div className="pricing_price_value bg-primary-subtle text-primary">
                                            <span className="pricing_monthly">
                                                 ₹999
                                            </span>
                                            <span className="pricing_annually">
                                                <del>₹11,988</del> ₹10,789 <sub>You'll Save <u>₹1,199</u> Annually</sub>
                                            </span>
                                        </div>
                                        <div className="pricing_block_title">
                                            <h3 className="pricing_package_title">Lite (500 GB)</h3>
                                            <p className="pricing_package_description mb-0">
                                                Centralise your data on Cloud
                                            </p>
                                        </div>
                                    </div>
                                    <ul className="icon_list unordered_list_block">
                                        <li>
                                            <span className="icon_list_icon">
                                                <i className="fa-regular fa-circle-check"></i>
                                            </span>
                                            <span className="icon_list_text">
                                                500 GB of storage for photos, files, etc.
                                            </span>
                                        </li>
                                        <li className='pricing_annually'>
                                            <span className="icon_list_icon">
                                                <i className="fa-regular fa-circle-check"></i>
                                            </span>
                                            <span className="icon_list_text">
                                            Save up to 10% for Annual plan
                                            </span>
                                        </li>
                                    </ul>
                                    <Link to="/contact" className="btn btn-light">
                                        <span className="btn_label" data-text="Order Now">Order Now</span>
                                        <span className="btn_icon">
                                            <i className="fa-solid fa-arrow-up-right"></i>
                                        </span>
                                    </Link>
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className={`pricing_block ${isActive ? 'active' : ''}`}>
                                    <div className="best_plan pricing_annually">
                                        <img src={offerBanner} alt="Best Offer" />
                                    </div>
                                    <div className="table_head">
                                        <div className="pricing_price_value bg-primary-subtle text-primary">
                                            <span className="pricing_monthly">
                                               ₹2999 
                                            </span>
                                            <span className="pricing_annually">
                                                <del>₹35,988</del> ₹32,389 <sub>You'll Save <u>₹3,599</u> Annually</sub>
                                            </span>
                                        </div>
                                        <div className="pricing_block_title">
                                            <h3 className="pricing_package_title">Basic (2 TB)</h3>
                                            <p className="pricing_package_description mb-0">
                                                Centralise your data on Cloud
                                            </p>
                                        </div>
                                    </div>
                                    <ul className="icon_list unordered_list_block">
                                        <li>
                                            <span className="icon_list_icon">
                                                <i className="fa-regular fa-circle-check"></i>
                                            </span>
                                            <span className="icon_list_text">
                                                2 TB of storage for photos, files, etc.
                                            </span>
                                        </li>
                                        <li className='pricing_annually'>
                                            <span className="icon_list_icon">
                                                <i className="fa-regular fa-circle-check"></i>
                                            </span>
                                            <span className="icon_list_text">
                                            Save up to 10% for Annual plan
                                            </span>
                                        </li>
                                    </ul>
                                    <a className="btn btn-light" href="/contact">
                                        <span className="btn_label" data-text="Order Now">Order Now</span>
                                        <span className="btn_icon">
                                            <i className="fa-solid fa-arrow-up-right"></i>
                                        </span>
                                    </a>
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className={`pricing_block ${isActive ? 'active' : ''}`}>
                                    <div className="table_head">
                                        <div className="pricing_price_value bg-primary-subtle text-primary">
                                            <span className="pricing_monthly">
                                               ₹3499 
                                            </span>
                                            <span className="pricing_annually">
                                                <del>₹41,988</del> ₹37,789 <sub>You'll Save <u>₹4,199</u> Annually</sub>
                                            </span>
                                        </div>
                                        <div className="pricing_block_title">
                                            <h3 className="pricing_package_title">Standard (5 TB)</h3>
                                            <p className="pricing_package_description mb-0">
                                                Centralise your data on Cloud
                                            </p>
                                        </div>
                                    </div>
                                    <ul className="icon_list unordered_list_block">
                                        <li>
                                            <span className="icon_list_icon">
                                                <i className="fa-regular fa-circle-check"></i>
                                            </span>
                                            <span className="icon_list_text">
                                                5 TB of storage for photos, files, etc.
                                            </span>
                                        </li>
                                        <li className='pricing_annually'>
                                            <span className="icon_list_icon">
                                                <i className="fa-regular fa-circle-check"></i>
                                            </span>
                                            <span className="icon_list_text">
                                            Save up to 10% for Annual plan
                                            </span>
                                        </li>
                                    </ul>
                                    <a className="btn btn-light" href="/contact">
                                        <span className="btn_label" data-text="Order Now">Order Now</span>
                                        <span className="btn_icon">
                                            <i className="fa-solid fa-arrow-up-right"></i>
                                        </span>
                                    </a>
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className={`pricing_block ${isActive ? 'active' : ''}`}>
                                    <div className="table_head">
                                        <div className="pricing_price_value bg-primary-subtle text-primary">
                                            <span className="pricing_monthly">
                                                ₹5999
                                            </span>
                                            <span className="pricing_annually">
                                                <del>₹71,988</del> ₹64,789 <sub>You'll Save <u>₹7,199</u> Annually</sub>
                                            </span>
                                        </div>
                                        <div className="pricing_block_title">
                                            <h3 className="pricing_package_title">Premium (10 TB)</h3>
                                            <p className="pricing_package_description mb-0">
                                                Centralise your data on Cloud
                                            </p>
                                        </div>
                                    </div>
                                    <ul className="icon_list unordered_list_block">
                                        <li>
                                            <span className="icon_list_icon">
                                                <i className="fa-regular fa-circle-check"></i>
                                            </span>
                                            <span className="icon_list_text">
                                                10 TB of storage for photos, files, etc.
                                            </span>
                                        </li>
                                        <li className='pricing_annually'>
                                            <span className="icon_list_icon">
                                                <i className="fa-regular fa-circle-check"></i>
                                            </span>
                                            <span className="icon_list_text">
                                            Save up to 10% for Annual plan
                                            </span>
                                        </li>
                                    </ul>
                                    <a className="btn btn-light" href="/contact">
                                        <span className="btn_label" data-text="Order Now">Order Now</span>
                                        <span className="btn_icon">
                                            <i className="fa-solid fa-arrow-up-right"></i>
                                        </span>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <div className="client_logo_section section_space bg-light">
                    <div className="container">
                        <div className="heading_block text-center">
                            <div className="heading_focus_text mb-0">
                                <span className="badge bg-secondary text-white">Brand We</span>
                                Work With 🎉
                            </div>
                        </div>
                        <PartnerSection/>
                    </div>
                </div>
            </main>
            <CtaSection />
            <Footer />
            <Scrollbar />
            <ModalVideo channel='youtube' autoplay isOpen={isOpen} videoId="7e90gBu4pas" onClose={() => setOpen(false)} />
        </Fragment>
    )
};
export default EnterprisePlans;
